"use client";

import React, { useState, useEffect, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom"; 
import { getTenantEmployees, deleteTenantEmployee } from "../../components/http";
import { FaTrash } from "react-icons/fa";
import TableTemplate from "../../components/TableTemplate/TableTemplate";
import Header from "../../components/header/header";
import EmployeeAddPopup from "./EmployeeAddPopup";
import Pagination from "../../components/Pagination/Pagination";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../components/PopUps/ConfirmDeleteButton";
import styles from "../../components/TableTemplate/TableTemplate.module.scss"

const TenantEmployeesPage = () => {
  const { t } = useTranslation("");
  const [employees, setEmployees] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  
  const limit = 3;
  const navigate = useNavigate(); 

  const fetchEmployees = async (page) => {
    setisLoading(true)
    try {
      const offset = (page - 1) * limit;
      const response = await getTenantEmployees(limit, offset);
      setEmployees(response.data);
      setTotalRecords(response.total_count);
      setisLoading(false)
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchEmployees(currentPage);
  }, [currentPage]);

  const handleDeleteEmployee = async (id) => {
    await ConfirmationModal({
      title:  t("employee.PopUp.delete"),
      text: t("employee.PopUp.deleteConfirm"),
      confirmButtonColor: "#d33",
      confirmButtonText:t("employee.PopUp.confirmButtonText"),
      cancelButtonText:t("employee.PopUp.cancelButtonText"),
      cancelButtonColor: "#3085d6",
      onConfirm: async () => {
        try {
          await deleteTenantEmployee(id);
          fetchEmployees(currentPage);
        } catch (error) {
          console.error("Ошибка удаления клиента:", error);
        }
      },
      onCancel: () => {
      },
      successTitle: t("employee.PopUp.deleted"),
      successText: t("employee.PopUp.deleteSucces")
    });
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    fetchEmployees(currentPage);
  };

  const handleRowClick = (id) => {
    navigate(`/employees/${id}`); 
  };  

  const headers=[
    t("employee.List.fullname"), 
    t("employee.List.post"),
  ]


  const renderRow = (employee) => {
    return (
      <>
        <div className={styles.cell} data-label={t("employee.List.fullname")}>
          {employee.fullname || t("employee.List.notSpecified")}
        </div>
        <div className={styles.cell} data-label={t("employee.List.post")}>
          {employee.post?.name || t("employee.List.notSpecified")}
        </div>
        {/* <div className={styles.cell}>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <FaTrash
              style={{ color: "red", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteEmployee(employee.id);
              }}
              title={t("employee.List.delete")}
            />
            <FaExternalLinkAlt
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => window.location.href = `/employees/${employee.id}`}
              title={t("employee.List.view")}
            />
          </div>
        </div> */}
      </>
    );
  };
  

  return (
    <>
      <Suspense fallback={<div>{t("loading")}</div>}>
        <Header 
          title={t("employee.List.title")} 
          onAddClick={() => setIsPopupOpen(true)} 
          showImportExport={false}
          onImportClick={null}
          onExportClick={null}
        />
        <TableTemplate
          headers={headers}
          data={employees}
          renderRow={renderRow}
          title={t("employee.List.title")}
          isLoading={isLoading}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(totalRecords / limit)}
          onPageChange={setCurrentPage}
        />
        {isPopupOpen && (
          <EmployeeAddPopup
            open={isPopupOpen}
            onClose={() => setIsPopupOpen(false)}
            onEmployeeAdded={handlePopupClose}
          />
        )}
      </Suspense>
    </>
  );
};

export default TenantEmployeesPage;
